export default "__VITE_ASSET__B3JzcNgX__"